import { Box, Button, Typography } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import SearchIcon from '@mui/icons-material/Search';
import ExploreIcon from '@mui/icons-material/Explore';
import { InvestorProfileType } from '@inversor-hub/types';
import SelectableCard from './SelectableCard';
import { ReactNode } from 'react';

interface StepProfileTypeProps {
  selected: InvestorProfileType | null;
  onSelect: (type: InvestorProfileType) => void;
  onContinue: () => void;
}

const options: {
  type: InvestorProfileType;
  icon: ReactNode;
  title: string;
  subtitle: string;
}[] = [
  {
    type: 'has_investments',
    icon: <ApartmentIcon />,
    title: 'Sí, ya tengo inversiones',
    subtitle: 'Tengo inmuebles en cartera y quiero gestionarlos mejor.',
  },
  {
    type: 'wants_to_start',
    icon: <SearchIcon />,
    title: 'Quiero empezar a invertir',
    subtitle: 'Estoy listo para hacer mi primera inversión inmobiliaria.',
  },
  {
    type: 'exploring',
    icon: <ExploreIcon />,
    title: 'Solo estoy explorando',
    subtitle: 'Quiero conocer la plataforma antes de decidir.',
  },
];

export default function StepProfileType({ selected, onSelect, onContinue }: StepProfileTypeProps) {
  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Bienvenido a InversorHub
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        ¿Ya tienes inversiones inmobiliarias?
      </Typography>

      <Box display="flex" flexDirection="column" gap={1.5}>
        {options.map((opt) => (
          <SelectableCard
            key={opt.type}
            icon={opt.icon}
            title={opt.title}
            subtitle={opt.subtitle}
            selected={selected === opt.type}
            onClick={() => onSelect(opt.type)}
          />
        ))}
      </Box>

      <Button
        variant="contained"
        color="primary"
        size="large"
        fullWidth
        disabled={!selected}
        onClick={onContinue}
        sx={{ mt: 3 }}
      >
        Continuar
      </Button>

      <Typography
        variant="caption"
        color="text.disabled"
        display="block"
        textAlign="center"
        sx={{ mt: 1.5 }}
      >
        Puedes cambiar esto más tarde en tu perfil.
      </Typography>
    </Box>
  );
}
